var _metadata, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 666.67 666.67",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 500h500v-500h-500z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 -1.3333 0 666.67)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h500v500h-500z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(256.18 173.66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1.791 10.83-11.341 16.998-22.205 16.76l-25.668 0.133c-18.419 0-26.145 23.328-26.145 36.062v46.774c0 12.734 7.726 36.062 26.145 36.062l25.668 0.132c10.864-0.237 20.414 5.931 22.205 16.761l5.133 30.944c2.149 13.092-7.879 23.751-21.25 23.99l-21.728-0.068c-30.084 0.239-69.241-17.25-86.552-50.455-9.073-14.878-13.61-33.444-13.61-55.938v-49.631c0-22.494 4.537-41.06 13.61-55.937 17.311-33.205 56.468-50.694 86.552-50.456l21.728-0.067c13.371 0.239 23.399 10.898 21.25 23.99z",
    fill: "#0a1920"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(258.69 220.28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1.744 0-3.291 0.901-4.139 2.409l-3.913 6.968c-1.013 1.806-0.848 3.994 0.402 5.323 3.552 3.778 5.51 8.751 5.51 14.007 0 5.188-1.958 10.123-5.515 13.894-1.247 1.326-1.414 3.508-0.404 5.307l3.938 7.007c0.85 1.514 2.396 2.416 4.141 2.416 1.237 0 2.418-0.474 3.33-1.336 7.465-7.042 11.747-16.99 11.747-27.288 0-10.473-4.177-20.193-11.761-27.368-0.912-0.866-2.096-1.339-3.336-1.339m24.7-46.185c-1.097 0-2.109 0.591-2.639 1.544l-6.887 12.347c-0.754 1.349-0.343 3.028 0.953 3.903 19.062 12.863 30.441 34.207 30.441 57.098 0 22.814-11.379 44.115-30.439 56.978-1.298 0.875-1.709 2.555-0.955 3.91l6.895 12.357c0.53 0.95 1.542 1.54 2.639 1.54 0.584 0 1.151-0.169 1.643-0.49 25.246-16.487 40.318-44.261 40.318-74.295 0-30.011-15.074-57.82-40.32-74.395-0.495-0.325-1.063-0.497-1.649-0.497m27.549-49.393c-1.057 0-1.993 0.542-2.503 1.453l-8.422 15.058c-0.743 1.325-0.347 2.975 0.901 3.754 36.283 22.583 57.945 61.468 57.945 104.02 0 42.488-21.662 81.331-57.943 103.9-1.248 0.778-1.646 2.429-0.903 3.754l8.422 15.058c0.51 0.911 1.446 1.453 2.503 1.453 0.548 0 1.087-0.153 1.563-0.448 43.41-26.781 69.326-73.03 69.326-123.72 0-50.759-25.916-97.053-69.326-123.84-0.476-0.292-1.015-0.444-1.563-0.444",
    fill: "#ec1846",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.5a14cdc5570492d440ab033c6458cd19.svg";
export { ForwardRef as ReactComponent };